'use client'

import { SellerSteps, TStepData } from '@/components/ui/SellerSteps'
import { AssignmentOutlined, CloudUploadOutlined, StorefrontOutlined } from '@mui/icons-material'
import { Box, Container, Stack, Typography } from '@mui/material'
import { ReactElement } from 'react'

export const ProcessSection = (): ReactElement => {
	const sellerOnboardingSteps: TStepData[] = [
		{
			id: 1,
			icon: AssignmentOutlined,
			title: 'Daftarkan dan Buat Toko Anda',
			shortTitle: 'Daftar & Buat Toko',
			description: 'Buat akun penjual Anda secara gratis dalam beberapa menit. Lengkapi informasi dasar toko Anda agar mudah dikenali pembeli.',
			image: '/assets/images/mobile-login-bro.svg'
		},
		{
			id: 2,
			icon: CloudUploadOutlined,
			title: 'Unggah dan Atur Produk Anda',
			shortTitle: 'Unggah Produk',
			description: 'Unggah foto dan deskripsi produk terbaik Anda. Atur stok dan harga dengan mudah melalui dashboard penjual yang intuitif.',
			image: '/assets/images/mobile-login-bro.svg'
		},
		{
			id: 3,
			icon: StorefrontOutlined,
			title: 'Mulai Berjualan',
			shortTitle: 'Mulai Berjualan',
			description: 'Toko dan produk Anda kini siap dilihat oleh jutaan calon pembeli. Pantau pesanan dan tingkatkan penjualan Anda.',
			image: '/assets/images/mobile-login-bro.svg'
		}
	]

	return (
		<section id='process-container'>
			<Box
				sx={{
					bgcolor: 'primary.main',
					py: { xs: 8, md: 12, lg: 28 },
					px: { xs: 2, md: 12, lg: 18 }
				}}
				className='w-full'>
				<Container maxWidth='lg'>
					<Stack spacing={8} alignItems='center'>
						<Typography
							variant='h2'
							color='white'
							align='center'
							sx={{
								fontWeight: 700,
								fontSize: { xs: '48px', md: '64px' },
								lineHeight: '55.8px'
							}}>
							Alur Kerja UMKMs
						</Typography>
						<SellerSteps steps={sellerOnboardingSteps} />
					</Stack>
				</Container>
			</Box>
		</section>
	)
}
